<ion-content class="theme-{{userService.theme}}" [ngClass]="{wallpaper: section !== 'question'}">
    <div class="start-wrap" *ngIf="section === 'start'">
        <div class="start-content">
            <div class="logo"><img src="assets/icon/alchemist-logo.svg"></div>
            <div class="title" [@enter] *ngIf="!!session">{{ 'Coaching Feedback' | translate }} - {{session?.start_at | amDateFormat : 'Do MMMM YYYY' }}</div>
            <div class="title" *ngIf="!session" style="width: 70%"><ion-skeleton-text animated style="width: 100%; height: 1em;"></ion-skeleton-text></div>
            <div class="text">{{ 'We hope you gained benefit from this coaching call.' | translate }}</div>
            <div class="text-smaller">{{ 'Could you please complete feedback so we can review our service - thank you.' | translate }}</div>
            <div><button (click)="start()">{{ "__COACH_START__" | translate }}</button></div>
            <div class="timer"><span></span>{{ 'Takes 3 minutes' | translate }}</div>
        </div>
        <div class="exit-link" (click)="goBack()">{{ 'Exit - Complete Later' | translate }}</div>
    </div>
    <div class="question-wrap"  *ngIf="section === 'question'">
        <div class="back" (click)="previous()" *ngIf="currentQuestion > 0"><img src="assets/img/back-white.svg"></div>
        <div class="logo"><img src="assets/icon/alchemist-logo.svg"></div>
        <div class="question-content">
            <div class="title"><div [@enter] [@leave] *ngIf="isTitle">{{ questions[currentQuestion].title }}</div></div>
            <div class="questions">
                <div (click)="answer('A')" [ngClass]="{selected: questions[currentQuestion].answer === 'A'}"><span>A</span> {{'Strongly Agree' | translate}}</div>
                <div (click)="answer('B')" [ngClass]="{selected: questions[currentQuestion].answer === 'B'}"><span>B</span> {{'Agree' | translate}}</div>
                <div (click)="answer('C')" [ngClass]="{selected: questions[currentQuestion].answer === 'C'}"><span>C</span> {{'Neither Agree nor Disagree' | translate}}</div>
                <div (click)="answer('D')" [ngClass]="{selected: questions[currentQuestion].answer === 'D'}"><span>D</span> {{'Disgree' | translate}}</div>
                <div (click)="answer('E')" [ngClass]="{selected: questions[currentQuestion].answer === 'E'}"><span>E</span> {{'Strongly Disgree' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="end-wrap" *ngIf="section === 'end'">
        <div class="end-content">
            <div class="logo"><img src="assets/icon/alchemist-logo.svg"></div>
            <div class="title">{{ 'Feedback Complete' | translate }}</div>
            <div class="text">{{ 'Many thanks for completing this feedback and we look forward to working with you again soon.' | translate }}</div>
            <div><button (click)="goBack()">Close</button></div>
        </div>
    </div>
</ion-content>
